module.exports = "/images/ef9d0e42e05a5ee2646f4fe86a88e144.svg";